import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminSftpUsersNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('sftp-user');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
